import * as React from 'react';
import { useEffect, useState } from 'react';
import { Link } from "react-router-dom";

// Modified scrollToElement to account for navbar height offset
function scrollToElement(id: string, setIsOpen: React.Dispatch<React.SetStateAction<boolean>>) {
  const element = document.getElementById(id);
  if (element) {
    // Try to get the navbar height for offset
    const navbar = document.querySelector('nav');
    // Get the element's position relative to the top of the document
    // If id is 'features', scroll even more to the bottom
    let elementTop = element.getBoundingClientRect().top + window.pageYOffset;
    if (id === "features") {
      const offset = navbar ? navbar.getBoundingClientRect().height : 0;
      // Scroll further down by 200px (adjust as needed)
      elementTop = elementTop - offset + 800;
    }
    window.scrollTo({
      top: elementTop,
      behavior: 'smooth'
    });
    setIsOpen(false);
  }
}

// Utility class for white hover text
const navHoverClass = "hover:text-white";

function Nav() {
  const oracleAlgo = "images/oracle-algo.svg";
  const oracleAlgoBlack = "images/oracle-algo-black.svg";
  // State to apply Navbar BG on hover
  const [scrolling, setScrolling] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 1) {
        setScrolling(true);
      } else {
        setScrolling(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : '';

    // Cleanup
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  return (
    <nav
      className={`glassmorphism max-xl:py-2 xl:w-[80%] xl:mx-[10%] xl:mt-12 mt-0 xl:rounded-2xl ml-0 max-xl:flex-col z-[1000] fixed w-full px-5 mx-xl:px-0 xl:px-8 xl:pt-0 ${scrolling ? "bg-black top-0 mt-0" : "bg-transparent"
        } ${isOpen && "max-xl:h-full z-50"}`}
    >
      {/* Logo */}
      <div className="flex items-center justify-between w-full max-xl:gap-4">
        <Link to="/oraclealgo" className={navHoverClass}>
          <img
            src={oracleAlgo}
            alt="Unity Academy"
            width={148}
            className="cursor-pointer"
          />
        </Link>

        {/* Hamburger Button */}
        <button
          className={`max-xl:block xl:hidden ${navHoverClass} ${isOpen ? "text-black" : "text-white"
            }`}
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Toggle navigation"
        >
          {isOpen ? (
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect y="13" width="28" height="2" fill="white" />
              <rect x="14" y="0" width="28" height="2" transform="rotate(90 14 0)" fill="white" />
            </svg>
          ) : (
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect y="4" width="28" height="4" fill="white" />
              <rect y="16" width="28" height="4" fill="white" />
            </svg>
          )}
        </button>

        {/* Navigation Links - Mobile Dropdown */}
        <div
          className={`max-xl:flex max-xl:flex-col max-xl:gap-y-1 max-xl:items-end max-xl:mt-0 max-xl:py-[30%] xl:flex xl:flex-row xl:gap-x-10 xl:items-center xl:mt-0 transition-all duration-300 ${isOpen
            ? "max-xl:block absolute top-0 h-full -z-10 right-0 left-0 w-full bg-transparent pr-10"
            : "max-xl:hidden"
            }`}
        >
          <button
            className={`hover:bg-transparent flex items-center justify-end text-white font-bold xl:h-full xl:text-white xl:text-opacity-50 xl:font-medium text-4xl xl:text-base p-4 ${navHoverClass}`}
            onClick={() => scrollToElement('features', setIsOpen)}
          >
            Features
          </button>
          <button
            className={`hover:bg-transparent flex items-center justify-end text-white font-bold xl:h-full xl:text-white xl:text-opacity-50 xl:font-medium text-4xl xl:text-base p-4 ${navHoverClass}`}
            onClick={() => scrollToElement('results', setIsOpen)}
          >
            Results
          </button>
          <button
            className={`hover:bg-transparent flex items-center justify-end text-white font-bold xl:h-full xl:text-white xl:text-opacity-50 xl:font-medium text-4xl xl:text-base p-4 ${navHoverClass}`}
            onClick={() => scrollToElement('pricing', setIsOpen)}
          >
            Pricing
          </button>
          <a
		  href="https://unityacademy.io"
		  className={`hover:bg-transparent flex items-center justify-end text-white font-bold xl:h-full xl:text-white xl:text-opacity-50 xl:font-medium text-4xl xl:text-base p-4 ${navHoverClass}`}
	      >
		  Unity Academy
		  </a>
          <a
            href="https://unity-academy.gitbook.io/oraclealgoguide/"
            className={`hover:bg-transparent flex items-center justify-end text-white font-bold xl:h-full xl:text-white xl:text-opacity-50 xl:font-medium text-4xl xl:text-base p-4 ${navHoverClass}`} target='_blank' rel='noopener noreferrer'
          >
            Guide
          </a>
          <a
            href="https://whop.com/oraclealgo-membership/"
            className={`max-xl:block xl:hidden hover:bg-transparent flex items-center justify-end text-white font-bold xl:h-full xl:text-white xl:text-opacity-50 xl:font-medium text-4xl xl:text-base p-4 ${navHoverClass}`}
          >
            Subscribe
          </a>
        </div>
        <div className='max-xl:hidden xl:block'>
          <a
            href="https://whop.com/oraclealgo-membership/"
            className={`px-[25px] py-[9px] rounded-[12px] flex gap-x-3 items-center flex-wrap ${navHoverClass}`}
          >
            <p className="text-base font-bold text-white">Subscribe</p>
            <img src="images/arrow-up-blue.svg" alt="Arrow Right" />
          </a>
        </div>
      </div>
    </nav>
  );
}

export default Nav;